var React = require('react');

function Approvved (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.15123 13.676C8.05887 13.676 7.96994 13.6594 7.88444 13.6262C7.79842 13.5934 7.72242 13.5441 7.65644 13.4781L4.35123 10.1729C4.23248 10.0542 4.17628 9.91219 4.18261 9.747C4.18947 9.58233 4.24568 9.44062 4.35123 9.32187C4.46998 9.20312 4.61196 9.14375 4.77715 9.14375C4.94182 9.14375 5.07693 9.20312 5.18248 9.32187L8.15123 12.2906L14.9992 5.44271C15.1047 5.32396 15.2432 5.26458 15.4148 5.26458C15.5863 5.26458 15.7248 5.32396 15.8304 5.44271C15.9492 5.56146 16.0085 5.70317 16.0085 5.86783C16.0085 6.03303 15.9492 6.175 15.8304 6.29375L8.64603 13.4781C8.58005 13.5441 8.50432 13.5934 8.41882 13.6262C8.33279 13.6594 8.2436 13.676 8.15123 13.676Z","fill":"white"}));
}

Approvved.defaultProps = {"width":"20","height":"19","viewBox":"0 0 20 19","fill":"none"};

module.exports = Approvved;

Approvved.default = Approvved;
